<template>
    <div class="question-content onboarding-step">
        <p class="question">
            {{ step }}. {{ control.data.question }}
        </p>
        <template v-if="'checkbox' === control.data.type">
            <checkbox-control
                v-model="answer"
                :layout="control.data.type"
                :options="control.data.options"
                :label="control.data.label"
            />
        </template>
        <template v-else-if="'range' !== control.data.type">
            <radio-control
                v-model="answer"
                :layout="control.data.type"
                :options="control.data.options"
                :label="control.data.label"
            />
        </template>
        <template v-else>
            <range-control
                v-model="answer"
                :layout="control.data.type"
                :options="control.data.options"
            />
        </template>
    </div>
</template>

<script>
import RadioControl from '@/components/Dashboard/Onboarding/Controls/RadioControl';
import RangeControl from './RangeControl';
import CheckboxControl from './CheckboxControl';

export default {
    components: {
        RadioControl,
        RangeControl,
        CheckboxControl,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
        control: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        answer: null,
    }),
};
</script>
